import {isFunction} from 'lodash';
import {Children, cloneElement, isValidElement, useCallback, useMemo} from 'react';

type Props = {
    className?: string;
    children?: React.ReactNode | React.ReactNode[];
    value?: any;
    selectable?: boolean;
    onChange?: (value: any) => void;
}

export const List: React.FC<Props> = ({className, children, value, selectable = true, onChange}: Props) => {
    const onClick = useCallback((newValue: any) => {
        onChange?.(value === newValue ? null : newValue);
    }, [value, onChange]);

    const childrenProps = useMemo(() => ({
        selectable,
        selectedValue: value,
        onClick,
    }), [selectable, value, onClick]);

    return (
        <div className={className}>
            {isFunction(children) ? children(childrenProps) : Children.map(children, (child) =>
                isValidElement(child) ? cloneElement(child, childrenProps) : null)}
        </div>
    );
};